/**
 * Estimate status constants shared across applications.
 */
import type { EstimateStatus, StatusIntents } from "../types/estimates";

/**
 * Estimate status configuration mapping status values to display text and intent.
 */
export const ESTIMATE_STATUSES: Record<
  EstimateStatus,
  { text: string; intent: StatusIntents }
> = {
  DRAFT: { text: "Draft", intent: "neutral" },
  ACCEPTED: { text: "Accepted", intent: "success" },
  DECLINED: { text: "Declined", intent: "danger" },
  INVOICED: { text: "Invoiced", intent: "success" },
  PENDING: { text: "Pending", intent: "neutral" },
  CHANGE_REQUESTED: { text: "Changes Requested", intent: "neutral" },
  CHANGE_UPDATED: { text: "Changes Updated", intent: "neutral" },
};
